<nb-menu [items]="menu"></nb-menu>
